import { render, staticRenderFns } from "./IncidentDetails.vue?vue&type=template&id=02bea22e"
import script from "./IncidentDetails.vue?vue&type=script&lang=js"
export * from "./IncidentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports